export default {
    key: "parish_interventions",
    folder: "parishInterventions",
    basePath: "parishinterventions",
};
